import { Component, EventEmitter, Input, OnInit, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import {AspCheckinReportService} from './asp-checkin-report.service'
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';


@Component({
  selector: 'app-asp-checkin-report',
  templateUrl: './asp-checkin-report.component.html',
  styleUrls: ['./asp-checkin-report.component.scss']
})
export class AspCheckinReportComponent implements OnInit {
  isBottomSheetOpen= false;
  currentPage: number = 1;
  totalPages: number = 2; 
  images: string[] = [];

 @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;
  data: any;
  accessories: any;
  accessoriesYes: any;
  damageImages: any;
  fuelMeterImage: any;
  isAccept: boolean;
  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
  Accepted: boolean;
  popupOpen: boolean;
  rejected: boolean;
  jobCardStatusPass: number;
  jobCard: string;
  bookingId: string;
  jobCardStatus: string;
  rejectedPopup: boolean;
  garageKey: string;
  constructor(
     private bottomSheet: MatBottomSheet,
     private renderer: Renderer2,
     private AspCheckinReportService:AspCheckinReportService,
     private http: HttpClient,
     private route: ActivatedRoute,
     private _fuseConfigService: FuseConfigService
  ) { }

  ngOnInit(): void {
    this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true }
      }
    };
    this.route.paramMap.subscribe(params => {
      const encoded = params.get('encoded');
      if (encoded) {
        try {
          const decoded = atob(encoded); // Base64 decode
          const [jobCard, bookingId, garageKey] = decoded.split('/');
  
          this.jobCard = jobCard;
          this.bookingId = bookingId;
          this.garageKey = garageKey;
        } catch (error) {
          console.error('Invalid encoded URL format', error);
        }
      }
    });
    this.checkInDetails();
  }

  @Output() changeTab = new EventEmitter<string>();

  openInformationTab() {
    this.changeTab.emit('Information'); 
    this.closeBottomSheet();
  }
  openMenu() {
    this.isBottomSheetOpen = true;
    
  }
   closeMenu(): void {
    this.isBottomSheetOpen = false;
  }
  openBottomSheet(): void {
    this.bottomSheet.open(this.bottomSheetTemplate,{
     panelClass: 'bottom-sheet-checkin'
    }
    );
  }
  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
 
  shareWithCustomer(): void {
    const spareSelectedGarageName= localStorage.getItem('spareSelectedGarageName');
    const message = `Hello ${this.data.customerName}, \n\n Your *Job Card ID:${this.jobCard}*. \n Here is your vehicle check-in report. \n\n A quotation will be shared with you shortly for approval. \n\nRegards,\n${spareSelectedGarageName}`;
   
    // WhatsApp API or Intent to share
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');

    this.closeMenu();
  }

  // Go to the next page
  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  // Go to the previous page
  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
 
 
  async downloadPDF() {
    const originalPage = this.currentPage;
    this.currentPage = 0;
  
    setTimeout(async () => {
      const doc = new jsPDF('p', 'mm', 'a4');
      const options = { scale: 1, useCORS: true };
  
      await this.waitForImagesToLoad();
  
      const pages = ['page1', 'page2', 'page3', 'page4', 'page5'];
      for (let i = 0; i < pages.length; i++) {
        const element = document.getElementById(pages[i]);
        if (element) {
          const canvas = await html2canvas(element, options);
          const imgData = canvas.toDataURL('image/png');
  
          const pdfWidth = doc.internal.pageSize.getWidth();
          const pdfHeight = doc.internal.pageSize.getHeight();
  
          const imgWidth = pdfWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
          let heightLeft = imgHeight;
          let position = 0;
  
          // ✅ Add a new page if not the first one
          if (i > 0) {
            doc.addPage();
          }
  
          // First page content
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pdfHeight;
  
          // Additional pages if content is taller than one page
          while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
          }
        }
      }
  
      doc.save('CheckInReport.pdf');
      this.currentPage = originalPage;
    }, 0);
  }
  
  
  
  // Helper method to wait for images to load
  waitForImagesToLoad(): Promise<void> {
    return new Promise((resolve) => {
      const images = Array.from(document.images);
      let loadedImagesCount = 0;
  
      images.forEach((img) => {
        if (img.complete) {
          loadedImagesCount++;
          if (loadedImagesCount === images.length) resolve();
        } else {
          img.onload = () => {
            loadedImagesCount++;
            if (loadedImagesCount === images.length) resolve();
          };
          img.onerror = () => {
            loadedImagesCount++;
            if (loadedImagesCount === images.length) resolve();
          };
        }
      });
  
      if (images.length === 0) resolve();
    });
  }
  
  checkInDetails(){
    let userKey = localStorage.getItem('spareUserKey');
    this.AspCheckinReportService.checkInDetails(this.garageKey, userKey, this.bookingId, this.jobCard).subscribe(
      result => {
        const res = JSON.parse(JSON.stringify(result));
        // console.log("checkinreport-response",result);
        this.data = res['data'];
        this.accessoriesYes = res['data'].accessories;
        this.damageImages = this.data.damageImages;
        this.jobCardStatus=this.data.jobCardStatus;
        this.images= this.data.images;
        this.fuelMeterImage = this.data.fuelMeterImage;
        // console.log("Data structure:", this.data); // Check the whole structure of data
        // console.log("fuelMeterImage in response:", this.data?.fuelMeterImage); // Check if fuelMeterImage is nested
        // Sort accessoriesImages in ascending order based on tag numbers
        if (this.data.accessoriesImages) {
          this.data.accessoriesImages.sort((a, b) => {
            const numA = parseInt(a.tag.replace('accessories_', ''), 10);
            const numB = parseInt(b.tag.replace('accessories_', ''), 10);
            return numA - numB;
          });
        }

      }
    );
    // this.getAccessoriesList();
}

// getAccessoriesList(){
//   this.AspCheckinReportService.getAccessoriesList().subscribe(
//     res => {
//       console.log("res", res);
//       this.accessories = res['data'].accessories;

//       // After getting the full list of accessories, match with the "Yes" accessories
//       this.accessories.forEach(item => {
//         // Check if this item is in the accessoriesYes list by comparing the description
//         item.isYes = this.accessoriesYes.some(yesItem => yesItem === item.description);
//       });

//       console.log(this.accessories); // Check the updated list
//     }
//   );
// }
Accept(){
  this.isAccept=!this.isAccept;
  this.Accepted=true;
  this.acceptReject()
}
reject(){
  this.popupOpen=true;
}
closePopup(){
  this.popupOpen=false;
}
rejectedYes(){
  this.rejectedPopup=true;
  this.popupOpen=false;
  this.rejected=true;
  this.acceptReject();
}
popupRejected(){
  this.rejectedPopup=false;
}
acceptReject(){

  if (this.Accepted== true) {
    this.jobCardStatusPass= 2;
  }
  if (this.rejected==true) {
    this.jobCardStatusPass= 0;
  }
  this.AspCheckinReportService.acceptReject( this.bookingId, this.jobCard, this.garageKey, this.jobCardStatusPass).subscribe(
    result => { 
      // console.log("result",result);
      this.jobCardStatus= result['data'].JobCardStatus
      // window.location.reload();
    })
}
}
